import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getButtonClasses } from '#pplx/frontend/aether/components/Button/classes.js';
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { ButtonPrimitive } from '#pplx/frontend/aether/primitives/ButtonPrimitive/index.js';
import { TabsMenuContent } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/TabsMenuContent.js';
import { useEntropyBrowser } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { useTabsAttachments } from '#pplx/frontend/apps/ask/hooks/comet-hooks/useCometTabsAttachments.js';
import { createStackedVisuals } from '#pplx/frontend/apps/ask/shared-ui-components/createStackedVisuals.js';
import { getBrowserFaviconUrl } from '#pplx/frontend/comet/client/utils.js';
import { memo, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
const MAX_FAVICON_ICONS = 3;
export const AttachedTabsBadge = memo(function AttachedTabsBadge({ tabs, onAddTab, onRemoveTab, }) {
    const [isOpen, setIsOpen] = useState(false);
    const cometBrowser = useEntropyBrowser();
    const { tabs: allTabs } = useTabsAttachments(cometBrowser);
    const triggerElement = useMemo(() => {
        const classes = getButtonClasses({
            pill: true,
            variant: 'tonal',
            size: 'small',
        });
        return (_jsx(ButtonPrimitive, { className: classes, children: _jsxs("div", { className: "flex items-center gap-2", children: [createStackedVisuals(tabs.map((tab) => {
                        const faviconUrl = tab.faviconUrl || getBrowserFaviconUrl(tab.url);
                        return (_jsx("img", { src: faviconUrl, alt: "", className: "size-full shrink-0 rounded-full", onError: (e) => {
                                e.currentTarget.style.display = 'none';
                            } }, tab.id));
                    }), {
                        isOverlapping: true,
                        maxVisuals: MAX_FAVICON_ICONS,
                        size: 'sm',
                        stackDirection: 'right',
                        containerClass: 'flex',
                        showRemainderCount: false,
                        overlappingClassName: 'overflow-hidden bg-soft ring-soft',
                    }), _jsx(FormattedMessage, { defaultMessage: "Tabs", description: "Badge label showing the number of attached browser tabs", id: "c394c2d78d" }), _jsx("span", { className: "text-tertiary", children: tabs.length })] }) }));
    }, [tabs]);
    return (_jsx(DropdownMenu, { isOpen: isOpen, onToggle: setIsOpen, triggerElement: triggerElement, minWidthPx: 230, maxWidthPx: 230, maxHeightPx: 310, children: _jsx(TabsMenuContent, { allTabs: allTabs, attachedTabs: tabs, onAddTab: onAddTab, onRemoveTab: onRemoveTab }) }));
});
AttachedTabsBadge.displayName = 'AttachedTabsBadge';
//# sourceMappingURL=AttachedTabsBadge.js.map